import { Box, Container, Stack, Typography } from '@mui/material'

export default function IndexPage() {
    return (
        <Container maxWidth="sm" sx={{ pt: 12 }}>
            <Stack spacing={3}>
                <Typography variant="h1" component="h1">
                    Fixrate
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    This is the Fixrate identity provider. Reach this page directly only if a client has redirected you here
                    for sign-in or to authorise an application.
                </Typography>
                <Box sx={{ mt: 4, fontSize: '0.85rem', color: 'text.disabled' }}>
                    idp.fixrate.no
                </Box>
            </Stack>
        </Container>
    )
}
